import "./Field.scss";

export default function FieldClone({ field }) {

  return (
    <div className="field-clone">
      {field.ui_type === 'title' && `Nadpis: ${field.title}`}
      {field.ui_type === 'customComponent' && `Vlastný komponent: ${field.customComponent}`}
      {field.ui_type === 'db_field' && field.title}
    </div>
  );
}
